module.exports = __webpack_public_path__ + "static/img/transactions.e47bb07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/demo/transactions.png
// module id = KUwx
// module chunks = 6